module.exports = __webpack_public_path__ + "img/Darker-2.51e1eaf.png";